document.addEventListener('DOMContentLoaded', function () {
    var sidebar = document.getElementById('sidebarMenu')
    if(sidebar && document.body.clientWidth < 991) {
        sidebar.addEventListener('shown.bs.collapse', function () {
            document.querySelector('body').style.position = 'fixed';
        });
        sidebar.addEventListener('hidden.bs.collapse', function () {
            document.querySelector('body').style.position = 'relative';
        });
    }
let navLinks = document.querySelectorAll(".side-nav-link");
let size = window.innerWidth;
function setAttr() {
  if (size > 992) {
    navLinks.forEach((link) => {
      link.removeAttribute("data-bs-toggle");
      link.removeAttribute("data-bs-target");
    });
  } else {
    navLinks.forEach((link) => {
      link.setAttribute("data-bs-toggle", "collapse");
      link.setAttribute("data-bs-target", "#sidebarMenu");
    });
  }
}

//function to update the size variable 
const updateWindowDimensions = () => {
  size = window.innerWidth;
};

// event listener to call the function to update the size variable and check the breakpoint
window.addEventListener("resize", () => {
  updateWindowDimensions();
  setAttr();
});

// call the function to set the attributes
setAttr();

// call on the document on load just for good measure
document.onload = () => {
  setAttr();
};

    //var myCollapse = document.getElementById('sidebarMenu')
    //$(document).on('click', function (e){
        //var menu_opened = $('#sidebarMenu').hasClass('show');
        //if(!$(e.target).closest('#sidebarMenu').length &&
            //!$(e.target).is('#sidebarMenu') &&
            //menu_opened === true){
                //new bootstrap.Collapse(myCollapse, {
                    //toggle: true
                //})
        //}
    //});

    // end click outside sidenav
    document.addEventListener("DOMContentLoaded", function(event) {
        var iconNotifications = document.querySelector('.notification-bell');
        if (iconNotifications) {
            iconNotifications.addEventListener('shown.bs.dropdown', function () {
                iconNotifications.classList.remove('unread');
            });
        }
    });
    var elements = document.getElementsByClassName("delete-self");
    var deleteSelfAlert = function(e) {
        const target = e.target;
        target.remove();
    };
    for (var i = 0; i < elements.length; i++) {
        elements[i].addEventListener('click', deleteSelfAlert, false);
    }
    // end
}, false);